import React, { useState, useEffect, useContext, useRef } from "react";
import * as S from "./styles";
import iconUser from "../../assets/user/account-circle.svg";
import iconPapeis from "../../assets/navbar/Convenios_on_light_blue.svg";

import Button from "../Button";
import api from "../../services/api";
import { BiTrash } from "react-icons/bi";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import InputMask from "react-input-mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { toast } from "react-toastify";
import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import { Formik, Form, Field } from "formik";

import PopUp from "../PopUp";
import SkeletonListItem from "../SkeletonListItem";
import CheckBox from "../Checkbox";
import Skeleton from "../skeleton";

import Select from "react-select";
import BorderedAutoCompleteSearch from "../BorderedAutoCompleteSearch";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function RolesComponent({ history, pageFilter }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const formRef = useRef(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageLimit, setPageLimit] = useState(9);
  const [popupOpen, setPopupOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({ id: null, cpf: null });
  const [users, setUsers] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [permissionsSelected, setPermissionsSelected] = useState([]);
  const [convenioId, setConvenioId] = useState(null);
  const [selected, setSelected] = useState(false);
  const [listConvenio, setListConvenio] = useState([]);
  const [initialState, setInitialState] = useState({
    addName: null,
    id: null,
    selectPermission: null,
    filteredConvenio: null,
  });

  async function getAllData(page = 0) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/api/papel?page=${page}&size=${pageLimit}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setUsers(response.data.content);
        setPage(page);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setUsers([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar aos papéis de usuários.");
      }

      setIsLoading(false);
    } catch (err) {
      setTotalPages(0);
      setTotalElements(0);
      setUsers([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar aos papéis de usuários.");
      }
    }
    setIsLoading(false);
  }

  async function getAllDataPermissions(page = 0) {
    try {
      setIsLoading(true);
      const response = await api.get(`/api/permissoes?page=${page}&size=1000`);

      if (response && (response.status === 201 || response.status === 200)) {
        setPermissions(
          response?.data?.content?.map((content) => {
            return { value: content.id, label: content.descricao };
          })
        );
      } else if (!response) {
        setPermissions([]);
        toast.error("Erro ao buscar aos papéis de usuários.");
      }

      setIsLoading(false);
    } catch (err) {
      setPermissions([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar aos papéis de usuários.");
      }
    }
    setIsLoading(false);
  }

  async function getAllConevnio() {
    setIsLoading(true);

    try {
      const response = await api.get(
        `api/convenio/buscar?cnpjOuNome=&page=0&size=2000`
      );
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content || [];
        setListConvenio(content);
      } else if (!response) {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (pageFilter) {
      setPage(pageFilter);
    }

    getAllData(pageFilter);
    getAllDataPermissions();
    getAllConevnio();
  }, [pageFilter]);

  const reloadPage = (page) => {
    history.replace(`?page=${page}`);
  };

  const sendData = async (dataForm) => {
    if (!dataForm || dataForm === null) {
      toast.error("Preencha um nome para o papel.");
      return;
    }

    if (
      !permissionsSelected ||
      permissionsSelected === null ||
      permissionsSelected.length === 0
    ) {
      toast.error("Selecione uma permissão para o papel.");
      return;
    }

    const dataSending = {
      nome: dataForm,
      status: true,
      papelPermissoes: permissionsSelected,
      convenio:
        convenioId && convenioId !== null
          ? {
              id: convenioId,
            }
          : null,
    };

    try {
      const response = await api.post("/api/papel ", dataSending);
      if (response && (response.status === 201 || response.status === 200)) {
        toast.success("Dados cadastrados com sucesso!");
      } else if (!response) {
        toast.error(
          "Erro ao salvar dados, verifique os dados e tente novamente!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao salvar dados, verifique os dados e tente novamente!"
        );
      }
    } finally {
      setPermissionsSelected([]);
      setConvenioId(null);
      setInitialState({
        addName: null,
        selectPermission: null,
        id: null,
      });

      getAllData();
      getAllDataPermissions();
      getAllConevnio();
    }
  };

  const HandleSubmit = (values, e) => {
    sendData(values);
  };

  const selectAutocomplete = async (item) => {
    if (typeof item === "string") return;

    setSelected(true);
    setConvenioId(item?.id || null);
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <Formik
            initialValues={initialState}
            onSubmit={async (values) => HandleSubmit}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <div className="boxSearch">
                  <Field
                    name="addName"
                    id="addName"
                    render={({ field }) => (
                      <InputMask
                        type="text"
                        placeholder="Nome do papel..."
                        value={values.addName}
                        onChange={(e) => {
                          setFieldValue("addName", e.target.value);
                        }}
                      />
                    )}
                  />
                  {!isLoading ? (
                    <S.SelectBox>
                      <Field
                        name="selectPermission"
                        id="selectPermission"
                        render={({ field }) => (
                          <Select
                            options={permissions}
                            isMulti
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Permissões..."
                            value={values.selectPermission}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 5,
                              colors: {
                                ...theme.colors,
                                primary25: "#00a2e0",
                                primary: "#00a2e0",
                              },
                            })}
                            onChange={(value) => {
                              setPermissionsSelected(
                                value?.map((val) => {
                                  return { permissoes: { id: val.value } };
                                })
                              );
                              setFieldValue("selectPermission", value);
                            }}
                          />
                        )}
                      />
                    </S.SelectBox>
                  ) : (
                    <>
                      <Skeleton type="input" />
                      <Skeleton type="input" />
                    </>
                  )}
                  <S.InputBox>
                    <Field
                      name="nomeConvenio"
                      id="nomeConvenio"
                      render={({ field }) =>
                        !isLoading ? (
                          <BorderedAutoCompleteSearch
                            title="Convênio"
                            label="Selecione seu convênio"
                            className="autocomplete"
                            showLabel={false}
                            listConvenio={listConvenio}
                            selected={selected}
                            handleSearch={selectAutocomplete}
                            initialValue={initialState.filteredConvenio}
                          />
                        ) : (
                          <Skeleton type="input" />
                        )
                      }
                    />
                  </S.InputBox>

                  <Button
                    type="submit"
                    className="button"
                    onClick={(e) => HandleSubmit(values.addName, e)}
                  >
                    Cadastrar papel
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
          <S.CardHeader>
            <span>
              {`${totalElements} ${
                totalElements > 1 ? "papéis" : "papel"
              } cadastrado${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {users &&
                users?.map((user) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info>
                          <img src={iconPapeis} alt="Icone usuário" />
                          <div className="dataCard">
                            <h4 className="h4-info">{user?.nome}</h4>
                          </div>
                        </S.Info>
                        <div className="iconService">
                          <BiTrash
                            id="trashIcon"
                            color="#00a2e0"
                            size={25}
                            onClick={() => {
                              setPopupOpen(true);
                              setUserSelected({ id: user.id, cpf: user.cpf });
                            }}
                          />
                        </div>
                      </S.Custumer>
                    </>
                  );
                })}

              {totalPages > 1 && (
                <TablePagination
                  component="div"
                  classes={{
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                  }}
                  count={totalElements}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return from + " - " + to + " de " + count;
                  }}
                  onPageChange={(p, newPage) => reloadPage(newPage)}
                  rowsPerPageOptions={[]}
                  rowsPerPage={pageLimit}
                />
              )}
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
        </S.Card>
      </S.Container>
      {popupOpen && (
        <PopUp
          setIsLoading={setIsLoading}
          setOpenPopup={setPopupOpen}
          userSelected={userSelected}
          page={page}
          updateList={getAllData}
          endPoint="/api/papel/"
          useMask="###.###.###-##"
          inativar={false}
          showCpfCnpj={false}
          textExclude={"Você deseja realmente excluir este papel de usuário?"}
          messageFailed={"Error ao excluir o papel de usuário"}
          messageSuccess={"Sucesso ao excluir o papel de usuário"}
        />
      )}
    </>
  );
}
